import React from "react";
import "../../styles/components/Admin/NameEllipses.scss";
import { Flyout } from "@els/els-react--flyout";

interface ActionDropDownType {
  actionList: any;
  toggleName: any;
  id: any;
  tabType: any;
}

const NameEllipses = (props: ActionDropDownType) => {
  return (
    <div className="ellipsesContainer">
      <Flyout
        trigger="hover"
        placement="bottom-start"
        theme="simple"
        modifiers={{ preventOverflow: [{ enabled: true }] }}
        flyout={props.actionList}
        id={props.id}
        className={`c-els-flyout--simple ${
          props.tabType === "asha"
            ? "ashaFlyout"
            : props.tabType === "patients"
            ? "patientsFlyout"
            : "flyoutAdditional"
        }`}
      >
        <p className="toggleName">{props.toggleName}</p>
      </Flyout>
    </div>
  );
};

export default NameEllipses;
